module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10193.838d493a.jpg";